import Box from "@mui/material/Box";
// ==============================================================


// ==============================================================
export default function BazaarImage(props) {
    const { isWhite, ...otherProps } = props;
    return (
        <Box
            component="img"
            sx={{
                filter: isWhite ? 'brightness(0) invert(1)' : 'none'
            }}
            {...otherProps}
        />
    );
}
